<template>
  <v-card class="base-card shadow">
    <v-card-title class="headline accent--text pb-4">
      {{ title }}
    </v-card-title>

    <v-card-text>
      <CardAutocompleteRow
        v-model="prePrint.commonWork.year"
        :items="yearList"
        item-value="id"
        item-text="year"
        label="Год публикации"
        :no-filter="false"
        placeholder="Выберите год публикации"
        :disabled="isShowMode"
        :error-messages="errorMessages.commonWork.year"
        :required="!isShowMode"
        @input="
          $v.prePrint.commonWork.year.$touch()
          updatePrePrintCard()
        "
      />

      <CardFieldRow
        v-model="prePrint.commonWork.workName"
        label="Наименование препринта"
        placeholder="Добавьте наименование препринта"
        :disabled="isShowMode"
        :error-messages="errorMessages.commonWork.workName"
        :required="!isShowMode"
        @input="
          $v.prePrint.commonWork.workName.$touch()
          updatePrePrintCard()
        "
      />

      <CardFieldRow
        v-model="prePrint.editionName"
        label="Наименование издания"
        placeholder="Добавьте наименование издания"
        :disabled="isShowMode"
        :error-messages="errorMessages.editionName"
        @input="
          $v.prePrint.editionName.$touch()
          updatePrePrintCard()
        "
      />

      <CardDateRow
        v-model="prePrint.applicationDate"
        label="Дата подачи заявки"
        placeholder="Добавьте дату подачи заявки"
        :disabled="isShowMode"
        :error-messages="errorMessages.applicationDate"
        @input="
          $v.prePrint.applicationDate.$touch()
          updatePrePrintCard()
        "
      />

      <CardAutocompleteRow
        v-model="prePrint.editionState"
        :items="stateList"
        item-value="id"
        item-text="name"
        label="Место публикации"
        placeholder="Выберите место публикации"
        :disabled="isShowMode"
        :no-filter="false"
        @input="updatePrePrintCard()"
      />

      <CardFieldRow
        v-model="prePrint.redactor"
        label="Редакторы"
        placeholder="Добавьте редакторов"
        :disabled="isShowMode"
        :error-messages="errorMessages.redactor"
        @input="
          $v.prePrint.redactor.$touch()
          updatePrePrintCard()
        "
      />

      <CardRadioRow
        v-model="prePrint.interactionType"
        label="Форма издания"
        :disabled="isShowMode"
        :value-list="interactionTypeList"
        :required="!isShowMode"
        @change="
          $v.prePrint.interactionType.$touch()
          updatePrePrintCard()
        "
      />

      <CardRadioRow
        v-model="prePrint.publicationForm"
        label="Форма научных трудов"
        hide-border-bottom
        :disabled="isShowMode"
        :value-list="publicationFormList"
        :required="!isShowMode"
        @change="
          $v.prePrint.publicationForm.$touch()
          updatePrePrintCard()
        "
      />

      <CardTextAreaRow
        v-model="prePrint.fullBibliographicDescription"
        label="Библиографическое содержание"
        placeholder="Формируется автоматически при заполнении всех необходимых полей"
        :disabled="isShowMode"
        readonly
        hide-border-bottom
        @input="updatePrePrintCard()"
      />
    </v-card-text>
  </v-card>
</template>

<script>
import { PrePrint } from '@/models'
import CardFieldRow from '../../ui/row/CardFieldRow'
import { setValidateMessages, checkDate } from '../../../scripts/validation'
import CardAutocompleteRow from '../../ui/row/CardAutocompleteRow'
import { required, maxLength } from 'vuelidate/lib/validators'
import CardTextAreaRow from '../../ui/row/CardTextAreaRow'
import CardDateRow from '../../ui/row/CardDateRow'
import { mapGetters } from 'vuex'
import { getFormatDate } from '@/scripts'
import CardRadioRow from '@/components/ui/row/CardRadioRow.vue'

export default {
  components: { CardRadioRow, CardDateRow, CardTextAreaRow, CardAutocompleteRow, CardFieldRow },
  props: {
    isShowMode: Boolean,
    selectedItem: Object,
    title: String,
    isDate: {
      type: Boolean,
      default: false
    }
  },

  data: () => ({
    prePrint: new PrePrint()
  }),

  validations() {
    return {
      prePrint: {
        commonWork: {
          workName: { required, maxLength: maxLength(1500) },
          year: { required }
        },

        interactionType: { required },
        publicationForm: { required },
        editionName: { maxLength: maxLength(300) },
        applicationDate: { checkDate },
        redactor: { maxLength: maxLength(300) }
      }
    }
  },

  computed: {
    ...mapGetters('dictionaries', ['yearList', 'stateList', 'interactionTypeList', 'publicationFormList']),

    applicationDate() {
      return getFormatDate(this.prePrint.applicationDate)
    },

    errorMessages() {
      const allErrors = { commonWork: {} }

      Object.keys(this.$v.prePrint.$params).forEach(key => {
        allErrors[key] = setValidateMessages(this.$v.prePrint[key])
      })

      Object.keys(this.$v.prePrint.commonWork.$params).forEach(key => {
        allErrors.commonWork[key] = setValidateMessages(this.$v.prePrint.commonWork[key])
      })

      return allErrors
    }
  },

  methods: {
    updateInvalid() {
      this.$emit('updateInvalid', this.$v.$invalid)
    },

    async updatePrePrintCard() {
      this.$emit('update:selected-item', new PrePrint(this.prePrint.getForAPI()))
    }
  },

  watch: {
    selectedItem: {
      immediate: true,
      deep: true,
      handler(val) {
        this.prePrint = new PrePrint(val && val.getForAPI())
        this.updateInvalid()
      }
    }
  }
}
</script>

<style scoped></style>
